module.exports = {"title":"Ooops, something went wrong","description":"It looks like you're trying to scan an invalid QR code or for an invalid date.","ok":"OK"}


//////////////////
// WEBPACK FOOTER
// ./src/components/Checkin/SuccessModal/locales/fr.json
// module id = 1388
// module chunks = 0